import React, { PureComponent } from 'react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'

class LanguageWarning extends PureComponent {
    render() {
        const { onHide, show } = this.props
        return (
            <Modal
                style={{ width: '450px', margin: 'auto' }}
                show={show}
                onClose={onHide}
            >
                <div className="uc-modal__header">
                    <p className="uc-modal__desc">{i18n.t('en_locale_warning')}</p>
                </div>
                <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                    <Button
                        cssClass="regular primary"
                        label={i18n.t('close')}
                        onClick={onHide}
                    />
                </div>
            </Modal>
        )
    }
}

export default LanguageWarning
